import { Helmet } from "react-helmet";
import CorporateCarHero from "./corporate_car/corporate_car-hero";
import CorporateCarLanding from "./corporate_car/corporate_car-landing";

export default function CorporateCar() {
    return (
        <>
            <Helmet>
                <title>Corporate Car Services in Hyderabad | PVR CABS</title>
                <meta name="description" content="Premium corporate car rental services across Hyderabad and Telangana. Book trusted transport for offices and business meetings." />
                <link rel="canonical" href="https://pvrcabs.com/corporate-car" />
            </Helmet>
            <div>
                <CorporateCarHero />
                <CorporateCarLanding />
            </div>
        </>
    )
}